import React from 'react';
import styled from 'styled-components';
import { Link } from '../Link';
import { StyledTab, StyledTabs } from '../Tabs';
import { useRouter } from 'next/router';
import { useStatChangeContext } from '../../hooks/useStatChangeContext';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const StyledLink = styled.a`
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 7px 2px !important;
  color: rgba(0, 0, 0, 0.38);
  text-align: center;
  flex-grow: 1;
  &.active-route {
    background-color: ${({ theme }) => theme.colorActive};
    color: white;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 7px !important;
  }
`;

const StyledLinkContainer = styled.div`
  display: flex;
  width: 100%;

  a:first-of-type {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }
  a:last-of-type {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  a:not(:last-of-type) {
    border-right: none;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
  align-items: center;
  justify-content: center;

  /* flex-direction: row;
  flex-wrap: wrap; */

  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
    justify-content: flex-start;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
  }
`;

const FullWidthDiv = styled.div`
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: auto;
  }
`;

const setInitialValue = (path: string) => {
  const paths = path.split('/');
  const lastPath = paths[paths.length - 1];
  if (lastPath.includes('over')) return 1;

  return 0;
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <FullWidthDiv
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <FullWidthDiv>{children}</FullWidthDiv>}
    </FullWidthDiv>
  );
}

const SmallTabs = styled(StyledTabs)`
  &&& {
    &.MuiTabs-root {
      min-height: 30px;
      height: 100%;
      width: 100%;
      ${({ theme }) => theme.breakpoints.up('sm')} {
        width: auto;
      }
    }
  }
`;

export const SmallTab = styled(StyledTab)`
  &&& {
    &.MuiTab-root {
      min-height: 30px;
      min-height: 0;
      padding: 0;
      ${({ theme }) => theme.breakpoints.up('sm')} {
        min-width: 100px;
        margin: 5px;
      }

      ${({ theme }) => theme.breakpoints.up('md')} {
        min-width: 160px;
      }
    }
  }
`;

interface TableStatsChangeProps {
  isUnderOver: boolean;
  allStatsVariants?: any[];
}
export const TableStatsChange = () => {
  const { isUnderOver, allStatsVariants } = useStatChangeContext();

  if (!isUnderOver || !allStatsVariants.length) {
    return null;
  }
  const { asPath } = useRouter();
  const [value, setValue] = React.useState<number>(setInitialValue(asPath));

  const handleTabsChange = (_, newValue: number) => {
    setValue(newValue);
  };
  const theme = useTheme();

  const isTablet = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <StyledContainer>
      <SmallTabs value={value} onChange={handleTabsChange} indicatorColor="primary" variant={isTablet ? 'standard' : 'fullWidth'} centered>
        <SmallTab label="Under" />
        <SmallTab label="Over" />
      </SmallTabs>
      <TabPanel value={value} index={0}>
        <StyledLinkContainer>
          {allStatsVariants.map((tile) => {
            return (
              <Link href={tile.under} key={`${tile.title}-${tile.under}`}>
                <StyledLink>{tile.title}</StyledLink>
              </Link>
            );
          })}
        </StyledLinkContainer>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <StyledLinkContainer>
          {allStatsVariants.map((tile) => {
            return (
              <Link href={tile.over} key={`${tile.title}-${tile.over}`}>
                <StyledLink>{tile.title}</StyledLink>
              </Link>
            );
          })}
        </StyledLinkContainer>
      </TabPanel>
      {/* <StyledTabs value={value} onChange={handleTabsChange} indicatorColor="primary" variant="scrollable" centered scrollButtons="on">
        {allPageTile.map((tile, index) => {
          return <StyledTab label={`Under ${tile.title}`} {...a11yProps(index)} />;
        })}
        {allPageTile.map((tile, index) => {
          return <StyledTab label={`Over ${tile.title}`} {...a11yProps(index + allPageTile.length)} />;
        })}
      </StyledTabs> */}
    </StyledContainer>
  );
};
